"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ring_1 = __importDefault(require("../../spinners/ring"));
const flags_1 = require("../../../requests/flags");
const error_handler_1 = __importDefault(require("../../../services/error_handler"));
const MarkSpamButton = ({ className, confirmMessage = null, flaggable, shouldConfirm = false, }) => {
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [flagged, setFlagged] = (0, react_1.useState)(false);
    const text = flagged ? 'Marked as spam' : 'Mark as spam';
    const handleConfirm = () => {
        if (!shouldConfirm) {
            return true; // skip confirmation
        }
        const message = confirmMessage
            || `Warning! This will also delete the ${flaggable.type ? flaggable.type.toLowerCase() : 'record'}. This action is irreversible. Are you sure?`;
        return window.confirm(message);
    };
    const createFlag = () => (0, flags_1.markAsSpam)(flaggable)
        .then(() => setFlagged(true))
        .catch((err) => (0, error_handler_1.default)('MarkSpamButton createFlag: ', err))
        .finally(() => setIsLoading(false));
    const handleClick = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (!isLoading && !flagged && handleConfirm()) {
            createFlag();
        }
        else {
            setIsLoading(false);
        }
    };
    return (react_1.default.createElement("button", { className: `flag-btn ${className}`, disabled: flagged, onClick: handleClick, type: "button" }, isLoading ? react_1.default.createElement(ring_1.default, { size: "16" }) : text));
};
exports.default = MarkSpamButton;
